export var CustomIcon;
(function (CustomIcon) {
    CustomIcon["DEUTSCHE_BAHN"] = "Deutsche_Bahn";
    CustomIcon["ALLIANZ_LOGO"] = "allianz-logo";
    CustomIcon["APPLE_WALLET_EN"] = "apple-wallet-en";
    CustomIcon["APPLE_WALLET_FI"] = "apple-wallet-fi";
    CustomIcon["AVIOS_KEYLINE_NAVY"] = "avios-keyline-navy";
    CustomIcon["AVIOS_KEYLINE_WHITE"] = "avios-keyline-white";
    CustomIcon["AVIOS_SMALL_USE_NAVY"] = "avios-small-use-navy";
    CustomIcon["AVIOS_SMALL_USE_WHITE"] = "avios-small-use-white";
    CustomIcon["BA_CLUB"] = "ba-club";
    CustomIcon["BAEC_EMBLEM"] = "baec-emblem";
    CustomIcon["BAEC_LOGO"] = "baec-logo";
    CustomIcon["BUSINESS_BASSINET_SEAT"] = "business-bassinet-seat";
    CustomIcon["CARTRAWLER_LOGO"] = "cartrawler-logo";
    CustomIcon["COMFORT_SEAT"] = "comfort-seat";
    CustomIcon["ECONOMY_BASSINET_SEAT"] = "economy-bassinet-seat";
    CustomIcon["EXIT_ROW_SEAT"] = "exit-row-seat";
    CustomIcon["EXTRA_LEGROOM_SEAT"] = "extra-legroom-seat";
    CustomIcon["FINNAIR_EMBLEM"] = "finnair-emblem";
    CustomIcon["FINNAIR_LOGO_100"] = "finnair-logo-100";
    CustomIcon["FINNAIR_LOGO_PLUS"] = "finnair-logo-plus";
    CustomIcon["FINNAIR_LOGO"] = "finnair-logo";
    CustomIcon["FRONT_ROW_SEAT"] = "front-row-seat";
    CustomIcon["GOOGLE_WALLET_EN"] = "google-wallet-en";
    CustomIcon["GOOGLE_WALLET_FI"] = "google-wallet-fi";
    CustomIcon["HOTELS_LOGO"] = "hotels-logo";
    CustomIcon["PLUS_CARD_BASIC_BG"] = "plus-card-basic-bg";
    CustomIcon["PLUS_CARD_BASIC"] = "plus-card-basic";
    CustomIcon["PLUS_CARD_GOLD_BG"] = "plus-card-gold-bg";
    CustomIcon["PLUS_CARD_GOLD"] = "plus-card-gold";
    CustomIcon["PLUS_CARD_JUNIOR_BG"] = "plus-card-junior-bg";
    CustomIcon["PLUS_CARD_JUNIOR"] = "plus-card-junior";
    CustomIcon["PLUS_CARD_LUMO_BG"] = "plus-card-lumo-bg";
    CustomIcon["PLUS_CARD_LUMO"] = "plus-card-lumo";
    CustomIcon["PLUS_CARD_PLATINUM_BG"] = "plus-card-platinum-bg";
    CustomIcon["PLUS_CARD_PLATINUM"] = "plus-card-platinum";
    CustomIcon["PLUS_CARD_SILVER_BG"] = "plus-card-silver-bg";
    CustomIcon["PLUS_CARD_SILVER"] = "plus-card-silver";
    CustomIcon["PLUS_ICON_BASIC"] = "plus-icon-basic";
    CustomIcon["PLUS_ICON_GOLD"] = "plus-icon-gold";
    CustomIcon["PLUS_ICON_LUMO"] = "plus-icon-lumo";
    CustomIcon["PLUS_ICON_PLATINUM"] = "plus-icon-platinum";
    CustomIcon["PLUS_ICON_SILVER"] = "plus-icon-silver";
    CustomIcon["PREFERRED_SEAT"] = "preferred-seat";
    CustomIcon["PREMIUM_BASSINET_SEAT"] = "premium-bassinet-seat";
    CustomIcon["PREMIUM_SEAT"] = "premium-seat";
    CustomIcon["REGULAR_SEAT"] = "regular-seat";
    CustomIcon["SELECTED_SEAT"] = "selected-seat";
    CustomIcon["UNAVAILABLE_SEAT"] = "unavailable-seat";
})(CustomIcon || (CustomIcon = {}));
;
export var PaymentsIcon;
(function (PaymentsIcon) {
    PaymentsIcon["ADYENPAYMENTCARD"] = "adyenpaymentcard";
    PaymentsIcon["AKTIA"] = "aktia";
    PaymentsIcon["ALANDSBANKEN"] = "alandsbanken";
    PaymentsIcon["ALIPAY"] = "alipay";
    PaymentsIcon["AMEX"] = "amex";
    PaymentsIcon["APPLEPAY"] = "applepay";
    PaymentsIcon["ARBEJDERNES"] = "arbejdernes";
    PaymentsIcon["BARCLAYS"] = "barclays";
    PaymentsIcon["CITADELE"] = "citadele";
    PaymentsIcon["COOPPANK"] = "cooppank";
    PaymentsIcon["DANSKEBANK"] = "danskebank";
    PaymentsIcon["DINERSCLUB"] = "dinersclub";
    PaymentsIcon["DISCOVER"] = "discover";
    PaymentsIcon["DNB"] = "dnb";
    PaymentsIcon["GIROPAY"] = "giropay";
    PaymentsIcon["HANDELSBANKEN"] = "handelsbanken";
    PaymentsIcon["HSBCUK"] = "hsbcuk";
    PaymentsIcon["IDEAL"] = "ideal";
    PaymentsIcon["INDIANETBANKING"] = "indianetbanking";
    PaymentsIcon["INDIAWALLET"] = "indiawallet";
    PaymentsIcon["JCB"] = "jcb";
    PaymentsIcon["JYSKEBANK"] = "jyskebank";
    PaymentsIcon["KLARNA"] = "klarna";
    PaymentsIcon["LANSFORSAKRINGAR"] = "lansforsakringar";
    PaymentsIcon["LHVPANK"] = "lhvpank";
    PaymentsIcon["LLOYDSBANK"] = "lloydsbank";
    PaymentsIcon["LUMINOR"] = "luminor";
    PaymentsIcon["LUNARBANK"] = "lunarbank";
    PaymentsIcon["MASTERCARD"] = "mastercard";
    PaymentsIcon["MOBILEPAY"] = "mobilepay";
    PaymentsIcon["NATWEST"] = "natwest";
    PaymentsIcon["NORDEA"] = "nordea";
    PaymentsIcon["NYKREDITBANK"] = "nykreditbank";
    PaymentsIcon["OMASP"] = "omasp";
    PaymentsIcon["OP"] = "op";
    PaymentsIcon["PAYPAL"] = "paypal";
    PaymentsIcon["POPPANKKI"] = "poppankki";
    PaymentsIcon["REVOLUT"] = "revolut";
    PaymentsIcon["RUPAY"] = "rupay";
    PaymentsIcon["SAASTOPANKKI"] = "saastopankki";
    PaymentsIcon["SANTANDERUK"] = "santanderuk";
    PaymentsIcon["SBANKEN"] = "sbanken";
    PaymentsIcon["SEB"] = "seb";
    PaymentsIcon["SOFORT"] = "sofort";
    PaymentsIcon["SPANKKI"] = "spankki";
    PaymentsIcon["SPAREBANK1NO"] = "sparebank1no";
    PaymentsIcon["SPAREBANK1SM"] = "sparebank1sm";
    PaymentsIcon["SPAREBANKOST"] = "sparebankost";
    PaymentsIcon["SWEDBANK"] = "swedbank";
    PaymentsIcon["SWISH"] = "swish";
    PaymentsIcon["TRUSTLY"] = "trustly";
    PaymentsIcon["UATP"] = "uatp";
    PaymentsIcon["UNIONPAY"] = "unionpay";
    PaymentsIcon["UPI"] = "upi";
    PaymentsIcon["VIPPS"] = "vipps";
    PaymentsIcon["VISA"] = "visa";
    PaymentsIcon["WECHATPAY"] = "wechatpay";
})(PaymentsIcon || (PaymentsIcon = {}));
;
export var SvgLibraryIcon;
(function (SvgLibraryIcon) {
    SvgLibraryIcon["ADULT_INFANT_BLOCK"] = "adult-infant-block";
    SvgLibraryIcon["ADULT_INFANT_OUTLINE"] = "adult-infant-outline";
    SvgLibraryIcon["ADULT_INFANT"] = "adult-infant";
    SvgLibraryIcon["AIRCRAFT_HORIZONTAL_BLOCK"] = "aircraft-horizontal-block";
    SvgLibraryIcon["AIRCRAFT_HORIZONTAL_OUTLINE"] = "aircraft-horizontal-outline";
    SvgLibraryIcon["AIRCRAFT_HORIZONTAL"] = "aircraft-horizontal";
    SvgLibraryIcon["AIRCRAFT_TILTED_BLOCK"] = "aircraft-tilted-block";
    SvgLibraryIcon["AIRCRAFT_TILTED_OUTLINE"] = "aircraft-tilted-outline";
    SvgLibraryIcon["AIRCRAFT_TILTED"] = "aircraft-tilted";
    SvgLibraryIcon["AIRCRAFT_VERTICAL_BLOCK"] = "aircraft-vertical-block";
    SvgLibraryIcon["AIRCRAFT_VERTICAL_OUTLINE"] = "aircraft-vertical-outline";
    SvgLibraryIcon["AIRCRAFT_VERTICAL"] = "aircraft-vertical";
    SvgLibraryIcon["AIRPORT_BLOCK"] = "airport-block";
    SvgLibraryIcon["AIRPORT_OUTLINE"] = "airport-outline";
    SvgLibraryIcon["AIRPORT"] = "airport";
    SvgLibraryIcon["ALERT_BLOCK"] = "alert-block";
    SvgLibraryIcon["ALERT_OUTLINE"] = "alert-outline";
    SvgLibraryIcon["ALERT_TRIANGLE"] = "alert-triangle";
    SvgLibraryIcon["ALERT"] = "alert";
    SvgLibraryIcon["AM_LOGO"] = "am-logo";
    SvgLibraryIcon["AREA_MAP_BLOCK"] = "area-map-block";
    SvgLibraryIcon["AREA_MAP_OUTLINE"] = "area-map-outline";
    SvgLibraryIcon["AREA_MAP"] = "area-map";
    SvgLibraryIcon["ARRIVAL_BLOCK"] = "arrival-block";
    SvgLibraryIcon["ARRIVAL_OUTLINE"] = "arrival-outline";
    SvgLibraryIcon["ARRIVAL"] = "arrival";
    SvgLibraryIcon["ARROW_BACK_BLOCK"] = "arrow-back-block";
    SvgLibraryIcon["ARROW_BACK_OUTLINE"] = "arrow-back-outline";
    SvgLibraryIcon["ARROW_BACK"] = "arrow-back";
    SvgLibraryIcon["ARROW_DOWN_BLOCK"] = "arrow-down-block";
    SvgLibraryIcon["ARROW_DOWN_OUTLINE"] = "arrow-down-outline";
    SvgLibraryIcon["ARROW_DOWN"] = "arrow-down";
    SvgLibraryIcon["ARROW_LEFT_BLOCK"] = "arrow-left-block";
    SvgLibraryIcon["ARROW_LEFT_OUTLINE"] = "arrow-left-outline";
    SvgLibraryIcon["ARROW_LEFT"] = "arrow-left";
    SvgLibraryIcon["ARROW_RIGHT_BLOCK"] = "arrow-right-block";
    SvgLibraryIcon["ARROW_RIGHT_OUTLINE"] = "arrow-right-outline";
    SvgLibraryIcon["ARROW_RIGHT"] = "arrow-right";
    SvgLibraryIcon["ARROW_UP_BLOCK"] = "arrow-up-block";
    SvgLibraryIcon["ARROW_UP_OUTLINE"] = "arrow-up-outline";
    SvgLibraryIcon["ARROW_UP"] = "arrow-up";
    SvgLibraryIcon["ATTACHMENT_BLOCK"] = "attachment-block";
    SvgLibraryIcon["ATTACHMENT_OUTLINE"] = "attachment-outline";
    SvgLibraryIcon["ATTACHMENT"] = "attachment";
    SvgLibraryIcon["AVIOS_CURRENCY"] = "avios-currency";
    SvgLibraryIcon["AVIOS_GIFT_CARD_BLOCK"] = "avios-gift-card-block";
    SvgLibraryIcon["AVIOS_GIFT_CARD_OUTLINE"] = "avios-gift-card-outline";
    SvgLibraryIcon["AVIOS_GIFT_CARD"] = "avios-gift-card";
    SvgLibraryIcon["AVIOS_MONO"] = "avios-mono";
    SvgLibraryIcon["AVIOS_PLECTRUM"] = "avios-plectrum";
    SvgLibraryIcon["B2B_BLOCK"] = "b2b-block";
    SvgLibraryIcon["B2B_OUTLINE"] = "b2b-outline";
    SvgLibraryIcon["B2B"] = "b2b";
    SvgLibraryIcon["BABY_BASSINET_BLOCK"] = "baby-bassinet-block";
    SvgLibraryIcon["BABY_BASSINET_OUTLINE"] = "baby-bassinet-outline";
    SvgLibraryIcon["BABY_BASSINET"] = "baby-bassinet";
    SvgLibraryIcon["BACKPACK_BLOCK"] = "backpack-block";
    SvgLibraryIcon["BACKPACK_OUTLINE"] = "backpack-outline";
    SvgLibraryIcon["BACKPACK"] = "backpack";
    SvgLibraryIcon["BAGGAGE_CHECKED_IN_BLOCK"] = "baggage-checked-in-block";
    SvgLibraryIcon["BAGGAGE_CHECKED_IN_OUTLINE"] = "baggage-checked-in-outline";
    SvgLibraryIcon["BAGGAGE_CHECKED_IN"] = "baggage-checked-in";
    SvgLibraryIcon["BAGGAGE_CLAIM_BLOCK"] = "baggage-claim-block";
    SvgLibraryIcon["BAGGAGE_CLAIM_OUTLINE"] = "baggage-claim-outline";
    SvgLibraryIcon["BAGGAGE_CLAIM"] = "baggage-claim";
    SvgLibraryIcon["BAGGAGE_WEIGHT_BLOCK"] = "baggage-weight-block";
    SvgLibraryIcon["BAGGAGE_WEIGHT_OUTLINE"] = "baggage-weight-outline";
    SvgLibraryIcon["BAGGAGE_WEIGHT"] = "baggage-weight";
    SvgLibraryIcon["BAGGAGE_WITH_TAG_BLOCK"] = "baggage-with-tag-block";
    SvgLibraryIcon["BAGGAGE_WITH_TAG_OUTLINE"] = "baggage-with-tag-outline";
    SvgLibraryIcon["BAGGAGE_WITH_TAG"] = "baggage-with-tag";
    SvgLibraryIcon["BEER_BLOCK"] = "beer-block";
    SvgLibraryIcon["BEER_OUTLINE"] = "beer-outline";
    SvgLibraryIcon["BEER"] = "beer";
    SvgLibraryIcon["BIKE_BLOCK"] = "bike-block";
    SvgLibraryIcon["BIKE_OUTLINE"] = "bike-outline";
    SvgLibraryIcon["BIKE"] = "bike";
    SvgLibraryIcon["BLOG_BLOCK"] = "blog-block";
    SvgLibraryIcon["BLOG_OUTLINE"] = "blog-outline";
    SvgLibraryIcon["BLOG"] = "blog";
    SvgLibraryIcon["BLUEBERRY_JUICE_BLOCK"] = "blueberry-juice-block";
    SvgLibraryIcon["BLUEBERRY_JUICE_OUTLINE"] = "blueberry-juice-outline";
    SvgLibraryIcon["BLUEBERRY_JUICE"] = "blueberry-juice";
    SvgLibraryIcon["BOOK_FLIGHT_BLOCK"] = "book-flight-block";
    SvgLibraryIcon["BOOK_FLIGHT_OUTLINE"] = "book-flight-outline";
    SvgLibraryIcon["BOOK_FLIGHT"] = "book-flight";
    SvgLibraryIcon["BREAKFAST_BLOCK"] = "breakfast-block";
    SvgLibraryIcon["BREAKFAST_OUTLINE"] = "breakfast-outline";
    SvgLibraryIcon["BREAKFAST"] = "breakfast";
    SvgLibraryIcon["BRIGHTNESS_BLOCK"] = "brightness-block";
    SvgLibraryIcon["BRIGHTNESS_LOW_BLOCK"] = "brightness-low-block";
    SvgLibraryIcon["BRIGHTNESS_LOW_OUTLINE"] = "brightness-low-outline";
    SvgLibraryIcon["BRIGHTNESS_LOW"] = "brightness-low";
    SvgLibraryIcon["BRIGHTNESS_MEDIUM_BLOCK"] = "brightness-medium-block";
    SvgLibraryIcon["BRIGHTNESS_MEDIUM_OUTLINE"] = "brightness-medium-outline";
    SvgLibraryIcon["BRIGHTNESS_MEDIUM"] = "brightness-medium";
    SvgLibraryIcon["BRIGHTNESS_OUTLINE"] = "brightness-outline";
    SvgLibraryIcon["BRIGHTNESS"] = "brightness";
    SvgLibraryIcon["BUS_BLOCK"] = "bus-block";
    SvgLibraryIcon["BUS_OUTLINE"] = "bus-outline";
    SvgLibraryIcon["BUS"] = "bus";
    SvgLibraryIcon["BUSINESS_CLASS_BLOCK"] = "business-class-block";
    SvgLibraryIcon["BUSINESS_CLASS_OUTLINE"] = "business-class-outline";
    SvgLibraryIcon["BUSINESS_CLASS"] = "business-class";
    SvgLibraryIcon["CALENDAR_BLOCK"] = "calendar-block";
    SvgLibraryIcon["CALENDAR_OUTLINE"] = "calendar-outline";
    SvgLibraryIcon["CALENDAR"] = "calendar";
    SvgLibraryIcon["CAMERA_BLOCK"] = "camera-block";
    SvgLibraryIcon["CAMERA_OUTLINE"] = "camera-outline";
    SvgLibraryIcon["CAMERA"] = "camera";
    SvgLibraryIcon["CAR_BLOCK"] = "car-block";
    SvgLibraryIcon["CAR_OUTLINE"] = "car-outline";
    SvgLibraryIcon["CAR"] = "car";
    SvgLibraryIcon["CARGO"] = "cargo";
    SvgLibraryIcon["CARRY_ON_BAG_BLOCK"] = "carry-on-bag-block";
    SvgLibraryIcon["CARRY_ON_BAG_OUTLINE"] = "carry-on-bag-outline";
    SvgLibraryIcon["CARRY_ON_BAG_TROLLEY_BLOCK"] = "carry-on-bag-trolley-block";
    SvgLibraryIcon["CARRY_ON_BAG_TROLLEY_OUTLINE"] = "carry-on-bag-trolley-outline";
    SvgLibraryIcon["CARRY_ON_BAG_TROLLEY"] = "carry-on-bag-trolley";
    SvgLibraryIcon["CARRY_ON_BAG"] = "carry-on-bag";
    SvgLibraryIcon["CARRY_ON_BAGGAGE_BLOCK"] = "carry-on-baggage-block";
    SvgLibraryIcon["CARRY_ON_BAGGAGE_OUTLINE"] = "carry-on-baggage-outline";
    SvgLibraryIcon["CARRY_ON_BAGGAGE"] = "carry-on-baggage";
    SvgLibraryIcon["CARRY_ON_PROHIBITED"] = "carry-on-prohibited";
    SvgLibraryIcon["CHAT_BLOCK"] = "chat-block";
    SvgLibraryIcon["CHAT_OUTLINE"] = "chat-outline";
    SvgLibraryIcon["CHAT"] = "chat";
    SvgLibraryIcon["CHECK_IN_BLOCK"] = "check-in-block";
    SvgLibraryIcon["CHECK_IN_OUTLINE"] = "check-in-outline";
    SvgLibraryIcon["CHECK_IN"] = "check-in";
    SvgLibraryIcon["CHECKBOX_SELECTED_INVERTED"] = "checkbox-selected-inverted";
    SvgLibraryIcon["CHECKBOX_SELECTED"] = "checkbox-selected";
    SvgLibraryIcon["CHECKBOX_UNSELECTED_INVERTED"] = "checkbox-unselected-inverted";
    SvgLibraryIcon["CHECKBOX_UNSELECTED"] = "checkbox-unselected";
    SvgLibraryIcon["CHECKED_BAG_PROHIBITED"] = "checked-bag-prohibited";
    SvgLibraryIcon["CHECKED_BAGGAGE_BLOCK"] = "checked-baggage-block";
    SvgLibraryIcon["CHECKED_BAGGAGE_OUTLINE"] = "checked-baggage-outline";
    SvgLibraryIcon["CHECKED_BAGGAGE"] = "checked-baggage";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE_BLOCK"] = "checked-in-baggage-block";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE_NONE_BLOCK"] = "checked-in-baggage-none-block";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE_NONE_OUTLINE"] = "checked-in-baggage-none-outline";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE_NONE"] = "checked-in-baggage-none";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE_OUTLINE"] = "checked-in-baggage-outline";
    SvgLibraryIcon["CHECKED_IN_BAGGAGE"] = "checked-in-baggage";
    SvgLibraryIcon["CHECKLIST_BLOCK"] = "checklist-block";
    SvgLibraryIcon["CHECKLIST_OUTLINE"] = "checklist-outline";
    SvgLibraryIcon["CHECKLIST"] = "checklist";
    SvgLibraryIcon["CHECKMARK_BLOCK"] = "checkmark-block";
    SvgLibraryIcon["CHECKMARK_BUTTON_SELECTED"] = "checkmark-button-selected";
    SvgLibraryIcon["CHECKMARK_BUTTON_UNSELECTED"] = "checkmark-button-unselected";
    SvgLibraryIcon["CHECKMARK_OUTLINE"] = "checkmark-outline";
    SvgLibraryIcon["CHECKMARK"] = "checkmark";
    SvgLibraryIcon["CHEVRON_DOWN_BLOCK"] = "chevron-down-block";
    SvgLibraryIcon["CHEVRON_DOWN_OUTLINE"] = "chevron-down-outline";
    SvgLibraryIcon["CHEVRON_DOWN"] = "chevron-down";
    SvgLibraryIcon["CHEVRON_LEFT_BLOCK"] = "chevron-left-block";
    SvgLibraryIcon["CHEVRON_LEFT_OUTLINE"] = "chevron-left-outline";
    SvgLibraryIcon["CHEVRON_LEFT"] = "chevron-left";
    SvgLibraryIcon["CHEVRON_RIGHT_BLOCK"] = "chevron-right-block";
    SvgLibraryIcon["CHEVRON_RIGHT_OUTLINE"] = "chevron-right-outline";
    SvgLibraryIcon["CHEVRON_RIGHT"] = "chevron-right";
    SvgLibraryIcon["CHEVRON_UP_BLOCK"] = "chevron-up-block";
    SvgLibraryIcon["CHEVRON_UP_OUTLINE"] = "chevron-up-outline";
    SvgLibraryIcon["CHEVRON_UP"] = "chevron-up";
    SvgLibraryIcon["CHILD_BLOCK"] = "child-block";
    SvgLibraryIcon["CHILD_OUTLINE"] = "child-outline";
    SvgLibraryIcon["CHILD"] = "child";
    SvgLibraryIcon["CLOCK"] = "clock";
    SvgLibraryIcon["CLOSE_DELETE_BLOCK"] = "close-delete-block";
    SvgLibraryIcon["CLOSE_DELETE_OUTLINE"] = "close-delete-outline";
    SvgLibraryIcon["CLOSE_DELETE"] = "close-delete";
    SvgLibraryIcon["CO2_BLOCK"] = "co2-block";
    SvgLibraryIcon["CO2_OUTLINE"] = "co2-outline";
    SvgLibraryIcon["CO2"] = "co2";
    SvgLibraryIcon["COFFEE_BLOCK"] = "coffee-block";
    SvgLibraryIcon["COFFEE_OUTLINE"] = "coffee-outline";
    SvgLibraryIcon["COFFEE"] = "coffee";
    SvgLibraryIcon["CONNECTING_FLIGHT_BLOCK"] = "connecting-flight-block";
    SvgLibraryIcon["CONNECTING_FLIGHT_OUTLINE"] = "connecting-flight-outline";
    SvgLibraryIcon["CONNECTING_FLIGHT"] = "connecting-flight";
    SvgLibraryIcon["COPY_BLOCK"] = "copy-block";
    SvgLibraryIcon["COPY_OUTLINE"] = "copy-outline";
    SvgLibraryIcon["COPY"] = "copy";
    SvgLibraryIcon["CORPORATE_BOOKING_BLOCK"] = "corporate-booking-block";
    SvgLibraryIcon["CORPORATE_BOOKING_OUTLINE"] = "corporate-booking-outline";
    SvgLibraryIcon["CORPORATE_BOOKING"] = "corporate-booking";
    SvgLibraryIcon["CORROSIVES_PROHIBITED"] = "corrosives-prohibited";
    SvgLibraryIcon["CORROSIVES"] = "corrosives";
    SvgLibraryIcon["COUPLE_BLOCK"] = "couple-block";
    SvgLibraryIcon["COUPLE_OUTLINE"] = "couple-outline";
    SvgLibraryIcon["COUPLE"] = "couple";
    SvgLibraryIcon["CREDIT_OR_DEBIT_CARD_BLOCK"] = "credit-or-debit-card-block";
    SvgLibraryIcon["CREDIT_OR_DEBIT_CARD_OUTLINE"] = "credit-or-debit-card-outline";
    SvgLibraryIcon["CREDIT_OR_DEBIT_CARD"] = "credit-or-debit-card";
    SvgLibraryIcon["CREW_CALLED_BLOCK"] = "crew-called-block";
    SvgLibraryIcon["CREW_CALLED_OUTLINE"] = "crew-called-outline";
    SvgLibraryIcon["CREW_CALLED"] = "crew-called";
    SvgLibraryIcon["CURRENCY_BLOCK"] = "currency-block";
    SvgLibraryIcon["CURRENCY_OUTLINE"] = "currency-outline";
    SvgLibraryIcon["CURRENCY"] = "currency";
    SvgLibraryIcon["CUSTOMER_SERVICE_BLOCK"] = "customer-service-block";
    SvgLibraryIcon["CUSTOMER_SERVICE_OUTLINE"] = "customer-service-outline";
    SvgLibraryIcon["CUSTOMER_SERVICE"] = "customer-service";
    SvgLibraryIcon["DAY_BLOCK"] = "day-block";
    SvgLibraryIcon["DAY_OUTLINE"] = "day-outline";
    SvgLibraryIcon["DAY"] = "day";
    SvgLibraryIcon["DEPARTURE_BLOCK"] = "departure-block";
    SvgLibraryIcon["DEPARTURE_GATE_BLOCK"] = "departure-gate-block";
    SvgLibraryIcon["DEPARTURE_GATE_OUTLINE"] = "departure-gate-outline";
    SvgLibraryIcon["DEPARTURE_GATE"] = "departure-gate";
    SvgLibraryIcon["DEPARTURE_OUTLINE"] = "departure-outline";
    SvgLibraryIcon["DEPARTURE"] = "departure";
    SvgLibraryIcon["DESTINATION_BLOCK"] = "destination-block";
    SvgLibraryIcon["DESTINATION_OUTLINE"] = "destination-outline";
    SvgLibraryIcon["DESTINATION"] = "destination";
    SvgLibraryIcon["DISCOUNT_BLOCK"] = "discount-block";
    SvgLibraryIcon["DISCOUNT_OUTLINE"] = "discount-outline";
    SvgLibraryIcon["DISCOUNT"] = "discount";
    SvgLibraryIcon["DISCOUNTED_PRICE_BLOCK"] = "discounted-price-block";
    SvgLibraryIcon["DISCOUNTED_PRICE_OUTLINE"] = "discounted-price-outline";
    SvgLibraryIcon["DISCOUNTED_PRICE"] = "discounted-price";
    SvgLibraryIcon["DOG_BLOCK"] = "dog-block";
    SvgLibraryIcon["DOG_OUTLINE"] = "dog-outline";
    SvgLibraryIcon["DOG"] = "dog";
    SvgLibraryIcon["DONATION_BLOCK"] = "donation-block";
    SvgLibraryIcon["DONATION_OUTLINE"] = "donation-outline";
    SvgLibraryIcon["DONATION"] = "donation";
    SvgLibraryIcon["DOWNLOAD_BLOCK"] = "download-block";
    SvgLibraryIcon["DOWNLOAD_OUTLINE"] = "download-outline";
    SvgLibraryIcon["DOWNLOAD"] = "download";
    SvgLibraryIcon["DRINK_SODA_BLOCK"] = "drink-soda-block";
    SvgLibraryIcon["DRINK_SODA_OUTLINE"] = "drink-soda-outline";
    SvgLibraryIcon["DRINK_SODA"] = "drink-soda";
    SvgLibraryIcon["E_CIGARETTE_PROHIBITED"] = "e-cigarette-prohibited";
    SvgLibraryIcon["E_CIGARETTE"] = "e-cigarette";
    SvgLibraryIcon["EDIT_BLOCK"] = "edit-block";
    SvgLibraryIcon["EDIT_OUTLINE"] = "edit-outline";
    SvgLibraryIcon["EDIT"] = "edit";
    SvgLibraryIcon["EIGHT_BLOCK"] = "eight-block";
    SvgLibraryIcon["EIGHT_OUTLINE"] = "eight-outline";
    SvgLibraryIcon["EIGHT"] = "eight";
    SvgLibraryIcon["ELECTRIC_SOCKET_BLOCK"] = "electric-socket-block";
    SvgLibraryIcon["ELECTRIC_SOCKET_OUTLINE"] = "electric-socket-outline";
    SvgLibraryIcon["ELECTRIC_SOCKET"] = "electric-socket";
    SvgLibraryIcon["EMAIL_BLOCK"] = "email-block";
    SvgLibraryIcon["EMAIL_OUTLINE"] = "email-outline";
    SvgLibraryIcon["EMAIL"] = "email";
    SvgLibraryIcon["EMPTY"] = "empty";
    SvgLibraryIcon["EXPAND_BLOCK"] = "expand-block";
    SvgLibraryIcon["EXPAND_OUTLINE"] = "expand-outline";
    SvgLibraryIcon["EXPAND"] = "expand";
    SvgLibraryIcon["EXPLOSIVES_PROHIBITED"] = "explosives-prohibited";
    SvgLibraryIcon["EXPLOSIVES"] = "explosives";
    SvgLibraryIcon["EXTERNAL_TAB_BLOCK"] = "external-tab-block";
    SvgLibraryIcon["EXTERNAL_TAB_OUTLINE"] = "external-tab-outline";
    SvgLibraryIcon["EXTERNAL_TAB"] = "external-tab";
    SvgLibraryIcon["EXTRA_CARRY_ON_BAG_BLOCK"] = "extra-carry-on-bag-block";
    SvgLibraryIcon["EXTRA_CARRY_ON_BAG_OUTLINE"] = "extra-carry-on-bag-outline";
    SvgLibraryIcon["EXTRA_CARRY_ON_BAG"] = "extra-carry-on-bag";
    SvgLibraryIcon["EXTRA_CHECK_IN_BAGGAGE_BLOCK"] = "extra-check-in-baggage-block";
    SvgLibraryIcon["EXTRA_CHECK_IN_BAGGAGE_OUTLINE"] = "extra-check-in-baggage-outline";
    SvgLibraryIcon["EXTRA_CHECK_IN_BAGGAGE"] = "extra-check-in-baggage";
    SvgLibraryIcon["EXTRA_LEG_ROOM_BLOCK"] = "extra-leg-room-block";
    SvgLibraryIcon["EXTRA_LEG_ROOM_OUTLINE"] = "extra-leg-room-outline";
    SvgLibraryIcon["EXTRA_LEG_ROOM"] = "extra-leg-room";
    SvgLibraryIcon["FACEBOOK_BLOCK"] = "facebook-block";
    SvgLibraryIcon["FACEBOOK_OUTLINE"] = "facebook-outline";
    SvgLibraryIcon["FACEBOOK"] = "facebook";
    SvgLibraryIcon["FACEMASK_BLOCK"] = "facemask-block";
    SvgLibraryIcon["FACEMASK_OUTLINE"] = "facemask-outline";
    SvgLibraryIcon["FACEMASK"] = "facemask";
    SvgLibraryIcon["FAMILY_BLOCK"] = "family-block";
    SvgLibraryIcon["FAMILY_OUTLINE"] = "family-outline";
    SvgLibraryIcon["FAMILY"] = "family";
    SvgLibraryIcon["FAVOURITE_ENTERTAINMENT_BLOCK"] = "favourite-entertainment-block";
    SvgLibraryIcon["FAVOURITE_ENTERTAINMENT_OUTLINE"] = "favourite-entertainment-outline";
    SvgLibraryIcon["FAVOURITE_ENTERTAINMENT"] = "favourite-entertainment";
    SvgLibraryIcon["FILTER_OPTIONS_BLOCK"] = "filter-options-block";
    SvgLibraryIcon["FILTER_OPTIONS_OUTLINE"] = "filter-options-outline";
    SvgLibraryIcon["FILTER_OPTIONS"] = "filter-options";
    SvgLibraryIcon["FINLAND_BLOCK"] = "finland-block";
    SvgLibraryIcon["FINLAND_OUTLINE"] = "finland-outline";
    SvgLibraryIcon["FINLAND"] = "finland";
    SvgLibraryIcon["FINNAIR_EMBLEM_BLOCK"] = "finnair-emblem-block";
    SvgLibraryIcon["FINNAIR_EMBLEM_OUTLINE"] = "finnair-emblem-outline";
    SvgLibraryIcon["FINNAIR_EMBLEM"] = "finnair-emblem";
    SvgLibraryIcon["FINNAIR_PLUS_BLOCK"] = "finnair-plus-block";
    SvgLibraryIcon["FINNAIR_PLUS_CARD_BLOCK"] = "finnair-plus-card-block";
    SvgLibraryIcon["FINNAIR_PLUS_CARD_OUTLINE"] = "finnair-plus-card-outline";
    SvgLibraryIcon["FINNAIR_PLUS_CARD"] = "finnair-plus-card";
    SvgLibraryIcon["FINNAIR_PLUS_OUTLINE"] = "finnair-plus-outline";
    SvgLibraryIcon["FINNAIR_PLUS"] = "finnair-plus";
    SvgLibraryIcon["FIRE_ARMS_PROHIBITED"] = "fire-arms-prohibited";
    SvgLibraryIcon["FIRE_ARMS"] = "fire-arms";
    SvgLibraryIcon["FIVE_BLOCK"] = "five-block";
    SvgLibraryIcon["FIVE_OUTLINE"] = "five-outline";
    SvgLibraryIcon["FIVE"] = "five";
    SvgLibraryIcon["FLAMMABLE_GASES_PROHIBITED"] = "flammable-gases-prohibited";
    SvgLibraryIcon["FLAMMABLE_GASES"] = "flammable-gases";
    SvgLibraryIcon["FLAMMABLE_LIQUIDS_PROHIBITED"] = "flammable-liquids-prohibited";
    SvgLibraryIcon["FLAMMABLE_LIQUIDS"] = "flammable-liquids";
    SvgLibraryIcon["FLAMMABLE_SOLIDS_PROHIBITED"] = "flammable-solids-prohibited";
    SvgLibraryIcon["FLAMMABLE_SOLIDS"] = "flammable-solids";
    SvgLibraryIcon["FLIGHT_CAMERA_BLOCK"] = "flight-camera-block";
    SvgLibraryIcon["FLIGHT_CAMERA_OUTLINE"] = "flight-camera-outline";
    SvgLibraryIcon["FLIGHT_CAMERA"] = "flight-camera";
    SvgLibraryIcon["FLIGHT_HOTEL"] = "flight-hotel";
    SvgLibraryIcon["FLIGHT_MAP_BLOCK"] = "flight-map-block";
    SvgLibraryIcon["FLIGHT_MAP_OUTLINE"] = "flight-map-outline";
    SvgLibraryIcon["FLIGHT_MAP"] = "flight-map";
    SvgLibraryIcon["FLIGHT_OFFER_BLOCK"] = "flight-offer-block";
    SvgLibraryIcon["FLIGHT_OFFER_OUTLINE"] = "flight-offer-outline";
    SvgLibraryIcon["FLIGHT_OFFER"] = "flight-offer";
    SvgLibraryIcon["FLIGHT_STATUS"] = "flight-status";
    SvgLibraryIcon["FLIGHTS_UNAVAILABLE_BLOCK"] = "flights-unavailable-block";
    SvgLibraryIcon["FLIGHTS_UNAVAILABLE_OUTLINE"] = "flights-unavailable-outline";
    SvgLibraryIcon["FLIGHTS_UNAVAILABLE"] = "flights-unavailable";
    SvgLibraryIcon["FOOD_BLOCK"] = "food-block";
    SvgLibraryIcon["FOOD_OUTLINE"] = "food-outline";
    SvgLibraryIcon["FOOD"] = "food";
    SvgLibraryIcon["FOUR_BLOCK"] = "four-block";
    SvgLibraryIcon["FOUR_OUTLINE"] = "four-outline";
    SvgLibraryIcon["FOUR"] = "four";
    SvgLibraryIcon["GAMES_BLOCK"] = "games-block";
    SvgLibraryIcon["GAMES_OUTLINE"] = "games-outline";
    SvgLibraryIcon["GAMES"] = "games";
    SvgLibraryIcon["GIFT_CARD_BLOCK"] = "gift-card-block";
    SvgLibraryIcon["GIFT_CARD_OUTLINE"] = "gift-card-outline";
    SvgLibraryIcon["GIFT_CARD"] = "gift-card";
    SvgLibraryIcon["GOLF_BLOCK"] = "golf-block";
    SvgLibraryIcon["GOLF_OUTLINE"] = "golf-outline";
    SvgLibraryIcon["GOLF_SKIS_BLOCK"] = "golf-skis-block";
    SvgLibraryIcon["GOLF_SKIS_OUTLINE"] = "golf-skis-outline";
    SvgLibraryIcon["GOLF_SKIS"] = "golf-skis";
    SvgLibraryIcon["GOLF"] = "golf";
    SvgLibraryIcon["GPS_LOCATION_BLOCK"] = "gps-location-block";
    SvgLibraryIcon["GPS_LOCATION_OUTLINE"] = "gps-location-outline";
    SvgLibraryIcon["GPS_LOCATION"] = "gps-location";
    SvgLibraryIcon["GROUP_BLOCK"] = "group-block";
    SvgLibraryIcon["GROUP_OUTLINE"] = "group-outline";
    SvgLibraryIcon["GROUP"] = "group";
    SvgLibraryIcon["HEADPHONES_BLOCK"] = "headphones-block";
    SvgLibraryIcon["HEADPHONES_OUTLINE"] = "headphones-outline";
    SvgLibraryIcon["HEADPHONES"] = "headphones";
    SvgLibraryIcon["HELP_BLOCK"] = "help-block";
    SvgLibraryIcon["HELP_OUTLINE"] = "help-outline";
    SvgLibraryIcon["HELP"] = "help";
    SvgLibraryIcon["HOLD_MY_BOOKING_BLOCK"] = "hold-my-booking-block";
    SvgLibraryIcon["HOLD_MY_BOOKING_OUTLINE"] = "hold-my-booking-outline";
    SvgLibraryIcon["HOLD_MY_BOOKING"] = "hold-my-booking";
    SvgLibraryIcon["HOME_BLOCK"] = "home-block";
    SvgLibraryIcon["HOME_OUTLINE"] = "home-outline";
    SvgLibraryIcon["HOME"] = "home";
    SvgLibraryIcon["HOTEL_BLOCK"] = "hotel-block";
    SvgLibraryIcon["HOTEL_OUTLINE"] = "hotel-outline";
    SvgLibraryIcon["HOTEL"] = "hotel";
    SvgLibraryIcon["IN_COMING_CALL_BLOCK"] = "in-coming-call-block";
    SvgLibraryIcon["IN_COMING_CALL_OUTLINE"] = "in-coming-call-outline";
    SvgLibraryIcon["IN_COMING_CALL"] = "in-coming-call";
    SvgLibraryIcon["INFANT_BLOCK"] = "infant-block";
    SvgLibraryIcon["INFANT_OUTLINE"] = "infant-outline";
    SvgLibraryIcon["INFANT"] = "infant";
    SvgLibraryIcon["INFO_BLOCK"] = "info-block";
    SvgLibraryIcon["INFO_OUTLINE"] = "info-outline";
    SvgLibraryIcon["INFO"] = "info";
    SvgLibraryIcon["INSTAGRAM"] = "instagram";
    SvgLibraryIcon["INSURANCE_BLOCK"] = "insurance-block";
    SvgLibraryIcon["INSURANCE_OUTLINE"] = "insurance-outline";
    SvgLibraryIcon["INSURANCE"] = "insurance";
    SvgLibraryIcon["INTERNET_DISRUPTION"] = "internet-disruption";
    SvgLibraryIcon["KEYBOARD_BLOCK"] = "keyboard-block";
    SvgLibraryIcon["KEYBOARD_OUTLINE"] = "keyboard-outline";
    SvgLibraryIcon["KEYBOARD"] = "keyboard";
    SvgLibraryIcon["LANGUAGE_BLOCK"] = "language-block";
    SvgLibraryIcon["LANGUAGE_OUTLINE"] = "language-outline";
    SvgLibraryIcon["LANGUAGE"] = "language";
    SvgLibraryIcon["LAPTOP_BLOCK"] = "laptop-block";
    SvgLibraryIcon["LAPTOP_OUTLINE"] = "laptop-outline";
    SvgLibraryIcon["LAPTOP"] = "laptop";
    SvgLibraryIcon["LAVATORY_BLOCK"] = "lavatory-block";
    SvgLibraryIcon["LAVATORY_MEN_BLOCK"] = "lavatory-men-block";
    SvgLibraryIcon["LAVATORY_MEN_OUTLINE"] = "lavatory-men-outline";
    SvgLibraryIcon["LAVATORY_MEN"] = "lavatory-men";
    SvgLibraryIcon["LAVATORY_OUTLINE"] = "lavatory-outline";
    SvgLibraryIcon["LAVATORY_WOMEN_BLOCK"] = "lavatory-women-block";
    SvgLibraryIcon["LAVATORY_WOMEN_OUTLINE"] = "lavatory-women-outline";
    SvgLibraryIcon["LAVATORY_WOMEN"] = "lavatory-women";
    SvgLibraryIcon["LAVATORY"] = "lavatory";
    SvgLibraryIcon["LEGISLATION_BLOCK"] = "legislation-block";
    SvgLibraryIcon["LEGISLATION_OUTLINE"] = "legislation-outline";
    SvgLibraryIcon["LEGISLATION"] = "legislation";
    SvgLibraryIcon["LIGHTERS_MATCHES_PROHIBITED"] = "lighters-matches-prohibited";
    SvgLibraryIcon["LIGHTERS_MATCHES"] = "lighters-matches";
    SvgLibraryIcon["LIGHTERS_PROHIBITED"] = "lighters-prohibited";
    SvgLibraryIcon["LIGHTERS"] = "lighters";
    SvgLibraryIcon["LIGHTS_OFF_BLOCK"] = "lights-off-block";
    SvgLibraryIcon["LIGHTS_OFF_OUTLINE"] = "lights-off-outline";
    SvgLibraryIcon["LIGHTS_OFF"] = "lights-off";
    SvgLibraryIcon["LIGHTS_ON_BLOCK"] = "lights-on-block";
    SvgLibraryIcon["LIGHTS_ON_OUTLINE"] = "lights-on-outline";
    SvgLibraryIcon["LIGHTS_ON"] = "lights-on";
    SvgLibraryIcon["LINK_BLOCK"] = "link-block";
    SvgLibraryIcon["LINK_OUTLINE"] = "link-outline";
    SvgLibraryIcon["LINK"] = "link";
    SvgLibraryIcon["LINKEDIN_BLOCK"] = "linkedin-block";
    SvgLibraryIcon["LINKEDIN_OUTLINE"] = "linkedin-outline";
    SvgLibraryIcon["LINKEDIN"] = "linkedin";
    SvgLibraryIcon["LIQUID_CONTAINER"] = "liquid-container";
    SvgLibraryIcon["LOCK_ACTIVE_BLOCK"] = "lock-active-block";
    SvgLibraryIcon["LOCK_ACTIVE_OUTLINE"] = "lock-active-outline";
    SvgLibraryIcon["LOCK_ACTIVE"] = "lock-active";
    SvgLibraryIcon["LOCK_CLOSED_BLOCK"] = "lock-closed-block";
    SvgLibraryIcon["LOCK_CLOSED_OUTLINE"] = "lock-closed-outline";
    SvgLibraryIcon["LOCK_CLOSED"] = "lock-closed";
    SvgLibraryIcon["LOCK_OPEN_BLOCK"] = "lock-open-block";
    SvgLibraryIcon["LOCK_OPEN_OUTLINE"] = "lock-open-outline";
    SvgLibraryIcon["LOCK_OPEN"] = "lock-open";
    SvgLibraryIcon["LOCKER_BLOCK"] = "locker-block";
    SvgLibraryIcon["LOCKER_OUTLINE"] = "locker-outline";
    SvgLibraryIcon["LOCKER"] = "locker";
    SvgLibraryIcon["LOGGED_IN_BLOCK"] = "logged-in-block";
    SvgLibraryIcon["LOGGED_IN_OUTLINE"] = "logged-in-outline";
    SvgLibraryIcon["LOGGED_IN"] = "logged-in";
    SvgLibraryIcon["LOGOUT_BLOCK"] = "logout-block";
    SvgLibraryIcon["LOGOUT_OUTLINE"] = "logout-outline";
    SvgLibraryIcon["LOGOUT"] = "logout";
    SvgLibraryIcon["LOST_BAGGAGE"] = "lost-baggage";
    SvgLibraryIcon["LOST_CARD"] = "lost-card";
    SvgLibraryIcon["LOUNGE_BLOCK"] = "lounge-block";
    SvgLibraryIcon["LOUNGE_OUTLINE"] = "lounge-outline";
    SvgLibraryIcon["LOUNGE"] = "lounge";
    SvgLibraryIcon["MAGAZINES_BLOCK"] = "magazines-block";
    SvgLibraryIcon["MAGAZINES_OUTLINE"] = "magazines-outline";
    SvgLibraryIcon["MAGAZINES"] = "magazines";
    SvgLibraryIcon["MAP_LAYERS_BLOCK"] = "map-layers-block";
    SvgLibraryIcon["MAP_LAYERS_OUTLINE"] = "map-layers-outline";
    SvgLibraryIcon["MAP_LAYERS"] = "map-layers";
    SvgLibraryIcon["MEAL_BLOCK"] = "meal-block";
    SvgLibraryIcon["MEAL_OUTLINE"] = "meal-outline";
    SvgLibraryIcon["MEAL"] = "meal";
    SvgLibraryIcon["MEDICAL_ASSISTANCE_BLOCK"] = "medical-assistance-block";
    SvgLibraryIcon["MEDICAL_ASSISTANCE_OUTLINE"] = "medical-assistance-outline";
    SvgLibraryIcon["MEDICAL_ASSISTANCE"] = "medical-assistance";
    SvgLibraryIcon["MENU_GRID_BLOCK"] = "menu-grid-block";
    SvgLibraryIcon["MENU_GRID_OUTLINE"] = "menu-grid-outline";
    SvgLibraryIcon["MENU_GRID"] = "menu-grid";
    SvgLibraryIcon["MENU_LIST_BLOCK"] = "menu-list-block";
    SvgLibraryIcon["MENU_LIST_OUTLINE"] = "menu-list-outline";
    SvgLibraryIcon["MENU_LIST_VIEW_BLOCK"] = "menu-list-view-block";
    SvgLibraryIcon["MENU_LIST_VIEW_OUTLINE"] = "menu-list-view-outline";
    SvgLibraryIcon["MENU_LIST_VIEW"] = "menu-list-view";
    SvgLibraryIcon["MENU_LIST"] = "menu-list";
    SvgLibraryIcon["MILESTONE_BLOCK"] = "milestone-block";
    SvgLibraryIcon["MILESTONE_OUTLINE"] = "milestone-outline";
    SvgLibraryIcon["MILESTONE"] = "milestone";
    SvgLibraryIcon["MINIMISE_BLOCK"] = "minimise-block";
    SvgLibraryIcon["MINIMISE_CHAT"] = "minimise-chat";
    SvgLibraryIcon["MINIMISE_OUTLINE"] = "minimise-outline";
    SvgLibraryIcon["MINIMISE"] = "minimise";
    SvgLibraryIcon["MINUS_BLOCK"] = "minus-block";
    SvgLibraryIcon["MINUS_OUTLINE"] = "minus-outline";
    SvgLibraryIcon["MINUS"] = "minus";
    SvgLibraryIcon["MMB_TICKET_CHANGES_BLOCK"] = "mmb-ticket-changes-block";
    SvgLibraryIcon["MMB_TICKET_CHANGES_OUTLINE"] = "mmb-ticket-changes-outline";
    SvgLibraryIcon["MMB_TICKET_CHANGES"] = "mmb-ticket-changes";
    SvgLibraryIcon["MOBILE_PHONE_BLOCK"] = "mobile-phone-block";
    SvgLibraryIcon["MOBILE_PHONE_OUTLINE"] = "mobile-phone-outline";
    SvgLibraryIcon["MOBILE_PHONE"] = "mobile-phone";
    SvgLibraryIcon["MORE_BLOCK"] = "more-block";
    SvgLibraryIcon["MORE_OUTLINE"] = "more-outline";
    SvgLibraryIcon["MORE"] = "more";
    SvgLibraryIcon["MOVIES_BLOCK"] = "movies-block";
    SvgLibraryIcon["MOVIES_OUTLINE"] = "movies-outline";
    SvgLibraryIcon["MOVIES"] = "movies";
    SvgLibraryIcon["MULTI_PAX_BLOCK"] = "multi-pax-block";
    SvgLibraryIcon["MULTI_PAX_OUTLINE"] = "multi-pax-outline";
    SvgLibraryIcon["MULTI_PAX"] = "multi-pax";
    SvgLibraryIcon["MULTISTOP_BLOCK"] = "multistop-block";
    SvgLibraryIcon["MULTISTOP_OUTLINE"] = "multistop-outline";
    SvgLibraryIcon["MULTISTOP"] = "multistop";
    SvgLibraryIcon["MUSIC_BLOCK"] = "music-block";
    SvgLibraryIcon["MUSIC_OUTLINE"] = "music-outline";
    SvgLibraryIcon["MUSIC"] = "music";
    SvgLibraryIcon["NIGHT_BLOCK"] = "night-block";
    SvgLibraryIcon["NIGHT_OUTLINE"] = "night-outline";
    SvgLibraryIcon["NIGHT"] = "night";
    SvgLibraryIcon["NINE_BLOCK"] = "nine-block";
    SvgLibraryIcon["NINE_OUTLINE"] = "nine-outline";
    SvgLibraryIcon["NINE"] = "nine";
    SvgLibraryIcon["NORDIC_PRODUCT_BLOCK"] = "nordic-product-block";
    SvgLibraryIcon["NORDIC_PRODUCT_OUTLINE"] = "nordic-product-outline";
    SvgLibraryIcon["NORDIC_PRODUCT"] = "nordic-product";
    SvgLibraryIcon["NOT_VISIBLE_BLOCK"] = "not-visible-block";
    SvgLibraryIcon["NOT_VISIBLE_OUTLINE"] = "not-visible-outline";
    SvgLibraryIcon["NOT_VISIBLE"] = "not-visible";
    SvgLibraryIcon["ONBOARD_SAFETY_BLOCK"] = "onboard-safety-block";
    SvgLibraryIcon["ONBOARD_SAFETY_OUTLINE"] = "onboard-safety-outline";
    SvgLibraryIcon["ONBOARD_SAFETY"] = "onboard-safety";
    SvgLibraryIcon["ONBOARD_SERVICE_BLOCK"] = "onboard-service-block";
    SvgLibraryIcon["ONBOARD_SERVICE_OUTLINE"] = "onboard-service-outline";
    SvgLibraryIcon["ONBOARD_SERVICE"] = "onboard-service";
    SvgLibraryIcon["ONE_BLOCK"] = "one-block";
    SvgLibraryIcon["ONE_OUTLINE"] = "one-outline";
    SvgLibraryIcon["ONE"] = "one";
    SvgLibraryIcon["ONEWORLD_LOGO"] = "oneworld-logo";
    SvgLibraryIcon["ONLINE_CHECKED_BLOCK"] = "online-checked-block";
    SvgLibraryIcon["ONLINE_CHECKED_OUTLINE"] = "online-checked-outline";
    SvgLibraryIcon["ONLINE_CHECKED"] = "online-checked";
    SvgLibraryIcon["PARKING"] = "parking";
    SvgLibraryIcon["PAUSE_BLOCK"] = "pause-block";
    SvgLibraryIcon["PAUSE_OUTLINE"] = "pause-outline";
    SvgLibraryIcon["PAUSE"] = "pause";
    SvgLibraryIcon["PAYMENT_METHODS_BLOCK"] = "payment-methods-block";
    SvgLibraryIcon["PAYMENT_METHODS_OUTLINE"] = "payment-methods-outline";
    SvgLibraryIcon["PAYMENT_METHODS"] = "payment-methods";
    SvgLibraryIcon["PERSON_BLOCK"] = "person-block";
    SvgLibraryIcon["PERSON_OUTLINE"] = "person-outline";
    SvgLibraryIcon["PERSON_SPECIAL_ASSIST_BLOCK"] = "person-special-assist-block";
    SvgLibraryIcon["PERSON_SPECIAL_ASSIST_OUTLINE"] = "person-special-assist-outline";
    SvgLibraryIcon["PERSON_SPECIAL_ASSIST"] = "person-special-assist";
    SvgLibraryIcon["PERSON_WALKING_BLOCK"] = "person-walking-block";
    SvgLibraryIcon["PERSON_WALKING_OUTLINE"] = "person-walking-outline";
    SvgLibraryIcon["PERSON_WALKING"] = "person-walking";
    SvgLibraryIcon["PERSON_WHEELCHAIR_BLOCK"] = "person-wheelchair-block";
    SvgLibraryIcon["PERSON_WHEELCHAIR_OUTLINE"] = "person-wheelchair-outline";
    SvgLibraryIcon["PERSON_WHEELCHAIR"] = "person-wheelchair";
    SvgLibraryIcon["PERSON"] = "person";
    SvgLibraryIcon["PET_IN_BAG_BLOCK"] = "pet-in-bag-block";
    SvgLibraryIcon["PET_IN_BAG_OUTLINE"] = "pet-in-bag-outline";
    SvgLibraryIcon["PET_IN_BAG"] = "pet-in-bag";
    SvgLibraryIcon["PET"] = "pet";
    SvgLibraryIcon["PHONE_BLOCK"] = "phone-block";
    SvgLibraryIcon["PHONE_OUTLINE"] = "phone-outline";
    SvgLibraryIcon["PHONE"] = "phone";
    SvgLibraryIcon["PICTURE_BLOCK"] = "picture-block";
    SvgLibraryIcon["PICTURE_OUTLINE"] = "picture-outline";
    SvgLibraryIcon["PICTURE"] = "picture";
    SvgLibraryIcon["PLAY_BLOCK"] = "play-block";
    SvgLibraryIcon["PLAY_NEXT_BLOCK"] = "play-next-block";
    SvgLibraryIcon["PLAY_NEXT_OUTLINE"] = "play-next-outline";
    SvgLibraryIcon["PLAY_NEXT"] = "play-next";
    SvgLibraryIcon["PLAY_OUTLINE"] = "play-outline";
    SvgLibraryIcon["PLAY_PREVIOUS_BLOCK"] = "play-previous-block";
    SvgLibraryIcon["PLAY_PREVIOUS_OUTLINE"] = "play-previous-outline";
    SvgLibraryIcon["PLAY_PREVIOUS"] = "play-previous";
    SvgLibraryIcon["PLAY"] = "play";
    SvgLibraryIcon["PLUS_BLOCK"] = "plus-block";
    SvgLibraryIcon["PLUS_OUTLINE"] = "plus-outline";
    SvgLibraryIcon["PLUS"] = "plus";
    SvgLibraryIcon["POINTS_OF_INTEREST_BLOCK"] = "points-of-interest-block";
    SvgLibraryIcon["POINTS_OF_INTEREST_OUTLINE"] = "points-of-interest-outline";
    SvgLibraryIcon["POINTS_OF_INTEREST"] = "points-of-interest";
    SvgLibraryIcon["POISON_PROHIBITED"] = "poison-prohibited";
    SvgLibraryIcon["POISON"] = "poison";
    SvgLibraryIcon["POWER_BANK_BLOCK"] = "power-bank-block";
    SvgLibraryIcon["POWER_BANK_OUTLINE"] = "power-bank-outline";
    SvgLibraryIcon["POWER_BANK_PROHIBITED"] = "power-bank-prohibited";
    SvgLibraryIcon["POWER_BANK"] = "power-bank";
    SvgLibraryIcon["POWER_BLOCK"] = "power-block";
    SvgLibraryIcon["POWER_OUTLINE"] = "power-outline";
    SvgLibraryIcon["POWER"] = "power";
    SvgLibraryIcon["PRE_ORDER_BLOCK"] = "pre-order-block";
    SvgLibraryIcon["PRE_ORDER_OUTLINE"] = "pre-order-outline";
    SvgLibraryIcon["PRE_ORDER"] = "pre-order";
    SvgLibraryIcon["PREMIUM_ECONOMY_BLOCK"] = "premium-economy-block";
    SvgLibraryIcon["PREMIUM_ECONOMY_OUTLINE"] = "premium-economy-outline";
    SvgLibraryIcon["PREMIUM_ECONOMY"] = "premium-economy";
    SvgLibraryIcon["PRICE_BLOCK"] = "price-block";
    SvgLibraryIcon["PRICE_OUTLINE"] = "price-outline";
    SvgLibraryIcon["PRICE"] = "price";
    SvgLibraryIcon["PRINT_BAG_TAG_BLOCK"] = "print-bag-tag-block";
    SvgLibraryIcon["PRINT_BAG_TAG_OUTLINE"] = "print-bag-tag-outline";
    SvgLibraryIcon["PRINT_BAG_TAG"] = "print-bag-tag";
    SvgLibraryIcon["PRIORITY_CHECK_IN_BLOCK"] = "priority-check-in-block";
    SvgLibraryIcon["PRIORITY_CHECK_IN_OUTLINE"] = "priority-check-in-outline";
    SvgLibraryIcon["PRIORITY_CHECK_IN"] = "priority-check-in";
    SvgLibraryIcon["PRIORITY_SECURITY_BLOCK"] = "priority-security-block";
    SvgLibraryIcon["PRIORITY_SECURITY_OUTLINE"] = "priority-security-outline";
    SvgLibraryIcon["PRIORITY_SECURITY"] = "priority-security";
    SvgLibraryIcon["QRCODE_BLOCK"] = "qrcode-block";
    SvgLibraryIcon["QRCODE_OUTLINE"] = "qrcode-outline";
    SvgLibraryIcon["QRCODE"] = "qrcode";
    SvgLibraryIcon["RADIO_SELECTED"] = "radio-selected";
    SvgLibraryIcon["RADIO_UNSELECTED"] = "radio-unselected";
    SvgLibraryIcon["RADIOACTIVE_PROHIBITED"] = "radioactive-prohibited";
    SvgLibraryIcon["RADIOACTIVE"] = "radioactive";
    SvgLibraryIcon["RADIOBUTTON_INVERTED_FILLED"] = "radiobutton-inverted-filled";
    SvgLibraryIcon["RE_FOCUS_BLOCK"] = "re-focus-block";
    SvgLibraryIcon["RE_FOCUS_OUTLINE"] = "re-focus-outline";
    SvgLibraryIcon["RE_FOCUS"] = "re-focus";
    SvgLibraryIcon["RENTAL_CAR_BLOCK"] = "rental-car-block";
    SvgLibraryIcon["RENTAL_CAR_OUTLINE"] = "rental-car-outline";
    SvgLibraryIcon["RENTAL_CAR"] = "rental-car";
    SvgLibraryIcon["RESERVATION_BLOCK"] = "reservation-block";
    SvgLibraryIcon["RESERVATION_OUTLINE"] = "reservation-outline";
    SvgLibraryIcon["RESERVATION"] = "reservation";
    SvgLibraryIcon["REST_BLOCK"] = "rest-block";
    SvgLibraryIcon["REST_OUTLINE"] = "rest-outline";
    SvgLibraryIcon["REST"] = "rest";
    SvgLibraryIcon["RETURN_TRIP_BLOCK"] = "return-trip-block";
    SvgLibraryIcon["RETURN_TRIP_OUTLINE"] = "return-trip-outline";
    SvgLibraryIcon["RETURN_TRIP"] = "return-trip";
    SvgLibraryIcon["RIDE_SHARE_BLOCK"] = "ride-share-block";
    SvgLibraryIcon["RIDE_SHARE_OUTLINE"] = "ride-share-outline";
    SvgLibraryIcon["RIDE_SHARE"] = "ride-share";
    SvgLibraryIcon["SAF_BLOCK"] = "saf-block";
    SvgLibraryIcon["SAF_OUTLINE"] = "saf-outline";
    SvgLibraryIcon["SAF"] = "saf";
    SvgLibraryIcon["SAVE_TIME"] = "save-time";
    SvgLibraryIcon["SCOOTER_PROHIBITED"] = "scooter-prohibited";
    SvgLibraryIcon["SCOOTER"] = "scooter";
    SvgLibraryIcon["SEAFOOD_BLOCK"] = "seafood-block";
    SvgLibraryIcon["SEAFOOD_OUTLINE"] = "seafood-outline";
    SvgLibraryIcon["SEAFOOD"] = "seafood";
    SvgLibraryIcon["SEARCH_BLOCK"] = "search-block";
    SvgLibraryIcon["SEARCH_OUTLINE"] = "search-outline";
    SvgLibraryIcon["SEARCH"] = "search";
    SvgLibraryIcon["SEAT_OR_ECONOMY_BLOCK"] = "seat-or-economy-block";
    SvgLibraryIcon["SEAT_OR_ECONOMY_OUTLINE"] = "seat-or-economy-outline";
    SvgLibraryIcon["SEAT_OR_ECONOMY"] = "seat-or-economy";
    SvgLibraryIcon["SEATBELTS_OFF_BLOCK"] = "seatbelts-off-block";
    SvgLibraryIcon["SEATBELTS_OFF_OUTLINE"] = "seatbelts-off-outline";
    SvgLibraryIcon["SEATBELTS_OFF"] = "seatbelts-off";
    SvgLibraryIcon["SEATBELTS_ON_BLOCK"] = "seatbelts-on-block";
    SvgLibraryIcon["SEATBELTS_ON_OUTLINE"] = "seatbelts-on-outline";
    SvgLibraryIcon["SEATBELTS_ON"] = "seatbelts-on";
    SvgLibraryIcon["SECURE_PAYMENT_BLOCK"] = "secure-payment-block";
    SvgLibraryIcon["SECURE_PAYMENT_OUTLINE"] = "secure-payment-outline";
    SvgLibraryIcon["SECURE_PAYMENT"] = "secure-payment";
    SvgLibraryIcon["SECURITY_BLOCK"] = "security-block";
    SvgLibraryIcon["SECURITY_OUTLINE"] = "security-outline";
    SvgLibraryIcon["SECURITY"] = "security";
    SvgLibraryIcon["SERVICE_DESK_BLOCK"] = "service-desk-block";
    SvgLibraryIcon["SERVICE_DESK_OUTLINE"] = "service-desk-outline";
    SvgLibraryIcon["SERVICE_DESK"] = "service-desk";
    SvgLibraryIcon["SETTINGS_BLOCK"] = "settings-block";
    SvgLibraryIcon["SETTINGS_OUTLINE"] = "settings-outline";
    SvgLibraryIcon["SETTINGS"] = "settings";
    SvgLibraryIcon["SEVEN_BLOCK"] = "seven-block";
    SvgLibraryIcon["SEVEN_OUTLINE"] = "seven-outline";
    SvgLibraryIcon["SEVEN"] = "seven";
    SvgLibraryIcon["SHARE_ANDROID_BLOCK"] = "share-android-block";
    SvgLibraryIcon["SHARE_ANDROID_OUTLINE"] = "share-android-outline";
    SvgLibraryIcon["SHARE_ANDROID"] = "share-android";
    SvgLibraryIcon["SHARP_OBJECTS_PROHIBITED"] = "sharp-objects-prohibited";
    SvgLibraryIcon["SHARP_OBJECTS"] = "sharp-objects";
    SvgLibraryIcon["SHOPPING_CART_ACTIVE"] = "shopping-cart-active";
    SvgLibraryIcon["SHOPPING_CART_BLOCK"] = "shopping-cart-block";
    SvgLibraryIcon["SHOPPING_CART_OUTLINE"] = "shopping-cart-outline";
    SvgLibraryIcon["SHOPPING_CART"] = "shopping-cart";
    SvgLibraryIcon["SHOWER_BLOCK"] = "shower-block";
    SvgLibraryIcon["SHOWER_OUTLINE"] = "shower-outline";
    SvgLibraryIcon["SHOWER"] = "shower";
    SvgLibraryIcon["SINGLE_PAX_BLOCK"] = "single-pax-block";
    SvgLibraryIcon["SINGLE_PAX_OUTLINE"] = "single-pax-outline";
    SvgLibraryIcon["SINGLE_PAX"] = "single-pax";
    SvgLibraryIcon["SIX_BLOCK"] = "six-block";
    SvgLibraryIcon["SIX_OUTLINE"] = "six-outline";
    SvgLibraryIcon["SIX"] = "six";
    SvgLibraryIcon["SKIP_15S_BACK_BLOCK"] = "skip-15s-back-block";
    SvgLibraryIcon["SKIP_15S_BACK_OUTLINE"] = "skip-15s-back-outline";
    SvgLibraryIcon["SKIP_15S_BACK"] = "skip-15s-back";
    SvgLibraryIcon["SKIP_15S_FORWARD_BLOCK"] = "skip-15s-forward-block";
    SvgLibraryIcon["SKIP_15S_FORWARD_OUTLINE"] = "skip-15s-forward-outline";
    SvgLibraryIcon["SKIP_15S_FORWARD"] = "skip-15s-forward";
    SvgLibraryIcon["SKIS_BLOCK"] = "skis-block";
    SvgLibraryIcon["SKIS_OUTLINE"] = "skis-outline";
    SvgLibraryIcon["SKIS"] = "skis";
    SvgLibraryIcon["SMOKING_BLOCK"] = "smoking-block";
    SvgLibraryIcon["SMOKING_OUTLINE"] = "smoking-outline";
    SvgLibraryIcon["SMOKING_PROHIBITED"] = "smoking-prohibited";
    SvgLibraryIcon["SMOKING"] = "smoking";
    SvgLibraryIcon["SNACKS_BLOCK"] = "snacks-block";
    SvgLibraryIcon["SNACKS_OUTLINE"] = "snacks-outline";
    SvgLibraryIcon["SNACKS"] = "snacks";
    SvgLibraryIcon["SORT_ASCENDING_BLOCK"] = "sort-ascending-block";
    SvgLibraryIcon["SORT_ASCENDING_OUTLINE"] = "sort-ascending-outline";
    SvgLibraryIcon["SORT_ASCENDING"] = "sort-ascending";
    SvgLibraryIcon["SORT_BLOCK"] = "sort-block";
    SvgLibraryIcon["SORT_DESCENDING_BLOCK"] = "sort-descending-block";
    SvgLibraryIcon["SORT_DESCENDING_OUTLINE"] = "sort-descending-outline";
    SvgLibraryIcon["SORT_DESCENDING"] = "sort-descending";
    SvgLibraryIcon["SORT_OUTLINE"] = "sort-outline";
    SvgLibraryIcon["SORT"] = "sort";
    SvgLibraryIcon["SPARE_LITHIUM_BATTERIES"] = "spare-lithium-batteries";
    SvgLibraryIcon["SPARKLING_WINE_BLOCK"] = "sparkling-wine-block";
    SvgLibraryIcon["SPARKLING_WINE_GLASS_BLOCK"] = "sparkling-wine-glass-block";
    SvgLibraryIcon["SPARKLING_WINE_GLASS_OUTLINE"] = "sparkling-wine-glass-outline";
    SvgLibraryIcon["SPARKLING_WINE_GLASS"] = "sparkling-wine-glass";
    SvgLibraryIcon["SPARKLING_WINE_OUTLINE"] = "sparkling-wine-outline";
    SvgLibraryIcon["SPARKLING_WINE"] = "sparkling-wine";
    SvgLibraryIcon["SPORTS_EQUIPMENT_BLOCK"] = "sports-equipment-block";
    SvgLibraryIcon["SPORTS_EQUIPMENT_OUTLINE"] = "sports-equipment-outline";
    SvgLibraryIcon["SPORTS_EQUIPMENT"] = "sports-equipment";
    SvgLibraryIcon["STAR_BLOCK"] = "star-block";
    SvgLibraryIcon["STAR_OUTLINE"] = "star-outline";
    SvgLibraryIcon["STAR"] = "star";
    SvgLibraryIcon["STOPOVER_BLOCK"] = "stopover-block";
    SvgLibraryIcon["STOPOVER_OUTLINE"] = "stopover-outline";
    SvgLibraryIcon["STOPOVER"] = "stopover";
    SvgLibraryIcon["SUBTITLES_BLOCK"] = "subtitles-block";
    SvgLibraryIcon["SUBTITLES_OUTLINE"] = "subtitles-outline";
    SvgLibraryIcon["SUBTITLES"] = "subtitles";
    SvgLibraryIcon["SURFBOARD_BLOCK"] = "surfboard-block";
    SvgLibraryIcon["SURFBOARD_OUTLINE"] = "surfboard-outline";
    SvgLibraryIcon["SURFBOARD"] = "surfboard";
    SvgLibraryIcon["SUSTAINABILITY_BLOCK"] = "sustainability-block";
    SvgLibraryIcon["SUSTAINABILITY_OUTLINE"] = "sustainability-outline";
    SvgLibraryIcon["SUSTAINABILITY"] = "sustainability";
    SvgLibraryIcon["SWITCH_FLIGHTS_BLOCK"] = "switch-flights-block";
    SvgLibraryIcon["SWITCH_FLIGHTS_OUTLINE"] = "switch-flights-outline";
    SvgLibraryIcon["SWITCH_FLIGHTS"] = "switch-flights";
    SvgLibraryIcon["TABLET_BLOCK"] = "tablet-block";
    SvgLibraryIcon["TABLET_OUTLINE"] = "tablet-outline";
    SvgLibraryIcon["TABLET"] = "tablet";
    SvgLibraryIcon["TAIL_BLOCK"] = "tail-block";
    SvgLibraryIcon["TAIL_OUTLINE"] = "tail-outline";
    SvgLibraryIcon["TAIL"] = "tail";
    SvgLibraryIcon["TAP_PRESS_BLOCK"] = "tap-press-block";
    SvgLibraryIcon["TAP_PRESS_OUTLINE"] = "tap-press-outline";
    SvgLibraryIcon["TAP_PRESS"] = "tap-press";
    SvgLibraryIcon["TAXI_BLOCK"] = "taxi-block";
    SvgLibraryIcon["TAXI_OUTLINE"] = "taxi-outline";
    SvgLibraryIcon["TAXI"] = "taxi";
    SvgLibraryIcon["TAZER_PROHIBITED"] = "tazer-prohibited";
    SvgLibraryIcon["TAZER"] = "tazer";
    SvgLibraryIcon["TEA_BLOCK"] = "tea-block";
    SvgLibraryIcon["TEA_OUTLINE"] = "tea-outline";
    SvgLibraryIcon["TEA"] = "tea";
    SvgLibraryIcon["THREE_BLOCK"] = "three-block";
    SvgLibraryIcon["THREE_OUTLINE"] = "three-outline";
    SvgLibraryIcon["THREE"] = "three";
    SvgLibraryIcon["TICKET_REFUND_BLOCK"] = "ticket-refund-block";
    SvgLibraryIcon["TICKET_REFUND_OUTLINE"] = "ticket-refund-outline";
    SvgLibraryIcon["TICKET_REFUND"] = "ticket-refund";
    SvgLibraryIcon["TIER_POINTS_BLOCK"] = "tier-points-block";
    SvgLibraryIcon["TIER_POINTS_OUTLINE"] = "tier-points-outline";
    SvgLibraryIcon["TIER_POINTS"] = "tier-points";
    SvgLibraryIcon["TIER_PROGRESS_BLOCK"] = "tier-progress-block";
    SvgLibraryIcon["TIER_PROGRESS_OUTLINE"] = "tier-progress-outline";
    SvgLibraryIcon["TIER_PROGRESS"] = "tier-progress";
    SvgLibraryIcon["TIKTOK_BLOCK"] = "tiktok-block";
    SvgLibraryIcon["TIKTOK_OUTLINE"] = "tiktok-outline";
    SvgLibraryIcon["TIKTOK"] = "tiktok";
    SvgLibraryIcon["TIME_ZONE_BLOCK"] = "time-zone-block";
    SvgLibraryIcon["TIME_ZONE_OUTLINE"] = "time-zone-outline";
    SvgLibraryIcon["TIME_ZONE"] = "time-zone";
    SvgLibraryIcon["TIMETABLE"] = "timetable";
    SvgLibraryIcon["TOOLS_AND_BLUNT_INSTRUMENTS_PROHIBITED"] = "tools-and-blunt-instruments-prohibited";
    SvgLibraryIcon["TOOLS_AND_BLUNT_INSTRUMENTS"] = "tools-and-blunt-instruments";
    SvgLibraryIcon["TRACK_PLAYING_BLOCK"] = "track-playing-block";
    SvgLibraryIcon["TRACK_PLAYING_OUTLINE"] = "track-playing-outline";
    SvgLibraryIcon["TRACK_PLAYING"] = "track-playing";
    SvgLibraryIcon["TRAIN_BLOCK"] = "train-block";
    SvgLibraryIcon["TRAIN_OUTLINE"] = "train-outline";
    SvgLibraryIcon["TRAIN"] = "train";
    SvgLibraryIcon["TRANSFER_LOADER_BLOCK"] = "transfer-loader-block";
    SvgLibraryIcon["TRANSFER_LOADER_OUTLINE"] = "transfer-loader-outline";
    SvgLibraryIcon["TRANSFER_LOADER"] = "transfer-loader";
    SvgLibraryIcon["TRASH_BLOCK"] = "trash-block";
    SvgLibraryIcon["TRASH_OUTLINE"] = "trash-outline";
    SvgLibraryIcon["TRASH"] = "trash";
    SvgLibraryIcon["TRAVEL_DOCUMENTS_BLOCK"] = "travel-documents-block";
    SvgLibraryIcon["TRAVEL_DOCUMENTS_OUTLINE"] = "travel-documents-outline";
    SvgLibraryIcon["TRAVEL_DOCUMENTS"] = "travel-documents";
    SvgLibraryIcon["TRAVEL_INSURANCE_BLOCK"] = "travel-insurance-block";
    SvgLibraryIcon["TRAVEL_INSURANCE_OUTLINE"] = "travel-insurance-outline";
    SvgLibraryIcon["TRAVEL_INSURANCE"] = "travel-insurance";
    SvgLibraryIcon["TREATS_BLOCK"] = "treats-block";
    SvgLibraryIcon["TREATS_OUTLINE"] = "treats-outline";
    SvgLibraryIcon["TREATS"] = "treats";
    SvgLibraryIcon["TRENDING_ARROW_UP"] = "trending-arrow-up";
    SvgLibraryIcon["TWENTY_FOUR_HOUR_REFUND_BLOCK"] = "twenty-four-hour-refund-block";
    SvgLibraryIcon["TWENTY_FOUR_HOUR_REFUND_OUTLINE"] = "twenty-four-hour-refund-outline";
    SvgLibraryIcon["TWENTY_FOUR_HOUR_REFUND"] = "twenty-four-hour-refund";
    SvgLibraryIcon["TWITTER"] = "twitter";
    SvgLibraryIcon["TWO_BLOCK"] = "two-block";
    SvgLibraryIcon["TWO_OUTLINE"] = "two-outline";
    SvgLibraryIcon["TWO"] = "two";
    SvgLibraryIcon["UPDATE_BLOCK"] = "update-block";
    SvgLibraryIcon["UPDATE_CART_BLOCK"] = "update-cart-block";
    SvgLibraryIcon["UPDATE_CART_OUTLINE"] = "update-cart-outline";
    SvgLibraryIcon["UPDATE_CART"] = "update-cart";
    SvgLibraryIcon["UPDATE_OUTLINE"] = "update-outline";
    SvgLibraryIcon["UPDATE"] = "update";
    SvgLibraryIcon["UPGRADE_BLOCK"] = "upgrade-block";
    SvgLibraryIcon["UPGRADE_OUTLINE"] = "upgrade-outline";
    SvgLibraryIcon["UPGRADE"] = "upgrade";
    SvgLibraryIcon["UPLOAD_BLOCK"] = "upload-block";
    SvgLibraryIcon["UPLOAD_OUTLINE"] = "upload-outline";
    SvgLibraryIcon["UPLOAD"] = "upload";
    SvgLibraryIcon["VAT_RECEIPT_DOWNLOAD_BLOCK"] = "vat-receipt-download-block";
    SvgLibraryIcon["VAT_RECEIPT_DOWNLOAD_OUTLINE"] = "vat-receipt-download-outline";
    SvgLibraryIcon["VAT_RECEIPT_DOWNLOAD"] = "vat-receipt-download";
    SvgLibraryIcon["VIDEO_SERIES_BLOCK"] = "video-series-block";
    SvgLibraryIcon["VIDEO_SERIES_OUTLINE"] = "video-series-outline";
    SvgLibraryIcon["VIDEO_SERIES"] = "video-series";
    SvgLibraryIcon["VISIBLE_BLOCK"] = "visible-block";
    SvgLibraryIcon["VISIBLE_OUTLINE"] = "visible-outline";
    SvgLibraryIcon["VISIBLE"] = "visible";
    SvgLibraryIcon["VOLUME_BLOCK"] = "volume-block";
    SvgLibraryIcon["VOLUME_LOW_BLOCK"] = "volume-low-block";
    SvgLibraryIcon["VOLUME_LOW_OUTLINE"] = "volume-low-outline";
    SvgLibraryIcon["VOLUME_LOW"] = "volume-low";
    SvgLibraryIcon["VOLUME_MEDIUM_BLOCK"] = "volume-medium-block";
    SvgLibraryIcon["VOLUME_MEDIUM_OUTLINE"] = "volume-medium-outline";
    SvgLibraryIcon["VOLUME_MEDIUM"] = "volume-medium";
    SvgLibraryIcon["VOLUME_MUTE_BLOCK"] = "volume-mute-block";
    SvgLibraryIcon["VOLUME_MUTE_OUTLINE"] = "volume-mute-outline";
    SvgLibraryIcon["VOLUME_MUTE"] = "volume-mute";
    SvgLibraryIcon["VOLUME_OUTLINE"] = "volume-outline";
    SvgLibraryIcon["VOLUME"] = "volume";
    SvgLibraryIcon["VOUCHER_BLOCK"] = "voucher-block";
    SvgLibraryIcon["VOUCHER_OUTLINE"] = "voucher-outline";
    SvgLibraryIcon["VOUCHER"] = "voucher";
    SvgLibraryIcon["WALLET_CLOSED_BLOCK"] = "wallet-closed-block";
    SvgLibraryIcon["WALLET_CLOSED_OUTLINE"] = "wallet-closed-outline";
    SvgLibraryIcon["WALLET_CLOSED"] = "wallet-closed";
    SvgLibraryIcon["WALLET_OPEN_BLOCK"] = "wallet-open-block";
    SvgLibraryIcon["WALLET_OPEN_OUTLINE"] = "wallet-open-outline";
    SvgLibraryIcon["WALLET_OPEN"] = "wallet-open";
    SvgLibraryIcon["WATER_BLOCK"] = "water-block";
    SvgLibraryIcon["WATER_OUTLINE"] = "water-outline";
    SvgLibraryIcon["WATER"] = "water";
    SvgLibraryIcon["WECHAT"] = "wechat";
    SvgLibraryIcon["WEIBO"] = "weibo";
    SvgLibraryIcon["WELLBEING_BLOCK"] = "wellbeing-block";
    SvgLibraryIcon["WELLBEING_OUTLINE"] = "wellbeing-outline";
    SvgLibraryIcon["WELLBEING"] = "wellbeing";
    SvgLibraryIcon["WHATSAPP_BLOCK"] = "whatsapp-block";
    SvgLibraryIcon["WHATSAPP_OUTLINE"] = "whatsapp-outline";
    SvgLibraryIcon["WHATSAPP"] = "whatsapp";
    SvgLibraryIcon["WIFI_AIRCRAFT"] = "wifi-aircraft";
    SvgLibraryIcon["WIFI_BLOCK"] = "wifi-block";
    SvgLibraryIcon["WIFI_LOW_BLOCK"] = "wifi-low-block";
    SvgLibraryIcon["WIFI_LOW_OUTLINE"] = "wifi-low-outline";
    SvgLibraryIcon["WIFI_LOW"] = "wifi-low";
    SvgLibraryIcon["WIFI_MEDIUM_BLOCK"] = "wifi-medium-block";
    SvgLibraryIcon["WIFI_MEDIUM_OUTLINE"] = "wifi-medium-outline";
    SvgLibraryIcon["WIFI_MEDIUM"] = "wifi-medium";
    SvgLibraryIcon["WIFI_OFFLINE_BLOCK"] = "wifi-offline-block";
    SvgLibraryIcon["WIFI_OFFLINE_OUTLINE"] = "wifi-offline-outline";
    SvgLibraryIcon["WIFI_OFFLINE"] = "wifi-offline";
    SvgLibraryIcon["WIFI_OUTLINE"] = "wifi-outline";
    SvgLibraryIcon["WIFI"] = "wifi";
    SvgLibraryIcon["WINE_BLOCK"] = "wine-block";
    SvgLibraryIcon["WINE_GLASS_BLOCK"] = "wine-glass-block";
    SvgLibraryIcon["WINE_GLASS_OUTLINE"] = "wine-glass-outline";
    SvgLibraryIcon["WINE_GLASS"] = "wine-glass";
    SvgLibraryIcon["WINE_OUTLINE"] = "wine-outline";
    SvgLibraryIcon["WINE"] = "wine";
    SvgLibraryIcon["WORLD_MAP_BLOCK"] = "world-map-block";
    SvgLibraryIcon["WORLD_MAP_OUTLINE"] = "world-map-outline";
    SvgLibraryIcon["WORLD_MAP"] = "world-map";
    SvgLibraryIcon["X_BLOCK"] = "x-block";
    SvgLibraryIcon["X_OUTLINE"] = "x-outline";
    SvgLibraryIcon["X"] = "x";
    SvgLibraryIcon["YOUKU"] = "youku";
    SvgLibraryIcon["YOUTUBE"] = "youtube";
    SvgLibraryIcon["ZERO_BLOCK"] = "zero-block";
    SvgLibraryIcon["ZERO_OUTLINE"] = "zero-outline";
    SvgLibraryIcon["ZERO"] = "zero";
})(SvgLibraryIcon || (SvgLibraryIcon = {}));
;
export var TailsIcon;
(function (TailsIcon) {
    TailsIcon["TAIL_3K"] = "tail_3k";
    TailsIcon["TAIL_6I"] = "tail_6i";
    TailsIcon["TAIL_9W"] = "tail_9w";
    TailsIcon["TAIL_A3"] = "tail_a3";
    TailsIcon["TAIL_AA"] = "tail_aa";
    TailsIcon["TAIL_AB"] = "tail_ab";
    TailsIcon["TAIL_AF"] = "tail_af";
    TailsIcon["TAIL_AI"] = "tail_ai";
    TailsIcon["TAIL_AS"] = "tail_as";
    TailsIcon["TAIL_AT"] = "tail_at";
    TailsIcon["TAIL_AY"] = "tail_ay";
    TailsIcon["TAIL_AZ"] = "tail_az";
    TailsIcon["TAIL_B6"] = "tail_b6";
    TailsIcon["TAIL_BA"] = "tail_ba";
    TailsIcon["TAIL_BR"] = "tail_br";
    TailsIcon["TAIL_BT"] = "tail_bt";
    TailsIcon["TAIL_BUS"] = "tail_bus";
    TailsIcon["TAIL_CA"] = "tail_ca";
    TailsIcon["TAIL_CI"] = "tail_ci";
    TailsIcon["TAIL_CX"] = "tail_cx";
    TailsIcon["TAIL_CZ"] = "tail_cz";
    TailsIcon["TAIL_DX"] = "tail_dx";
    TailsIcon["TAIL_EI"] = "tail_ei";
    TailsIcon["TAIL_EK"] = "tail_ek";
    TailsIcon["TAIL_ET"] = "tail_et";
    TailsIcon["TAIL_FI"] = "tail_fi";
    TailsIcon["TAIL_FJ"] = "tail_fj";
    TailsIcon["TAIL_GA"] = "tail_ga";
    TailsIcon["TAIL_GL"] = "tail_gl";
    TailsIcon["TAIL_HO"] = "tail_ho";
    TailsIcon["TAIL_HU"] = "tail_hu";
    TailsIcon["TAIL_IB"] = "tail_ib";
    TailsIcon["TAIL_IG"] = "tail_ig";
    TailsIcon["TAIL_IJ"] = "tail_ij";
    TailsIcon["TAIL_JL"] = "tail_jl";
    TailsIcon["TAIL_JP"] = "tail_jp";
    TailsIcon["TAIL_JU"] = "tail_ju";
    TailsIcon["TAIL_KA"] = "tail_ka";
    TailsIcon["TAIL_KE"] = "tail_ke";
    TailsIcon["TAIL_KL"] = "tail_kl";
    TailsIcon["TAIL_KM"] = "tail_km";
    TailsIcon["TAIL_LA"] = "tail_la";
    TailsIcon["TAIL_LG"] = "tail_lg";
    TailsIcon["TAIL_LH"] = "tail_lh";
    TailsIcon["TAIL_LM"] = "tail_lm";
    TailsIcon["TAIL_LO"] = "tail_lo";
    TailsIcon["TAIL_LX"] = "tail_lx";
    TailsIcon["TAIL_MH"] = "tail_mh";
    TailsIcon["TAIL_MI"] = "tail_mi";
    TailsIcon["TAIL_MU"] = "tail_mu";
    TailsIcon["TAIL_NT"] = "tail_nt";
    TailsIcon["TAIL_NZ"] = "tail_nz";
    TailsIcon["TAIL_OK"] = "tail_ok";
    TailsIcon["TAIL_OO"] = "tail_oo";
    TailsIcon["TAIL_OS"] = "tail_os";
    TailsIcon["TAIL_OU"] = "tail_ou";
    TailsIcon["TAIL_OZ"] = "tail_oz";
    TailsIcon["TAIL_PG"] = "tail_pg";
    TailsIcon["TAIL_PR"] = "tail_pr";
    TailsIcon["TAIL_PS"] = "tail_ps";
    TailsIcon["TAIL_QF"] = "tail_qf";
    TailsIcon["TAIL_QR"] = "tail_qr";
    TailsIcon["TAIL_RJ"] = "tail_rj";
    TailsIcon["TAIL_S7"] = "tail_s7";
    TailsIcon["TAIL_SB"] = "tail_sb";
    TailsIcon["TAIL_SK"] = "tail_sk";
    TailsIcon["TAIL_SN"] = "tail_sn";
    TailsIcon["TAIL_SQ"] = "tail_sq";
    TailsIcon["TAIL_SU"] = "tail_su";
    TailsIcon["TAIL_SV"] = "tail_sv";
    TailsIcon["TAIL_TF"] = "tail_tf";
    TailsIcon["TAIL_TG"] = "tail_tg";
    TailsIcon["TAIL_TK"] = "tail_tk";
    TailsIcon["TAIL_TN"] = "tail_tn";
    TailsIcon["TAIL_TP"] = "tail_tp";
    TailsIcon["TAIL_TRN"] = "tail_trn";
    TailsIcon["TAIL_UK"] = "tail_uk";
    TailsIcon["TAIL_UL"] = "tail_ul";
    TailsIcon["TAIL_VN"] = "tail_vn";
    TailsIcon["TAIL_WF"] = "tail_wf";
    TailsIcon["TAIL_WY"] = "tail_wy";
})(TailsIcon || (TailsIcon = {}));
;
export var IconLibrary;
(function (IconLibrary) {
    IconLibrary["CUSTOM"] = "custom";
    IconLibrary["PAYMENTS"] = "payments";
    IconLibrary["SVG_LIBRARY"] = "svg-library";
    IconLibrary["TAILS"] = "tails";
})(IconLibrary || (IconLibrary = {}));
;
